export default [
  'buy_good_requested',
  'stop_rent_requested',
  'waiting_for_return',
  'good_returned',
  'returned_good_check',
  'closed',
  'cancelled',
];
